import { render, staticRenderFns } from "./productImgStyle.vue?vue&type=template&id=1a360714&scoped=true"
import script from "./productImgStyle.vue?vue&type=script&lang=js"
export * from "./productImgStyle.vue?vue&type=script&lang=js"
import style0 from "./productImgStyle.vue?vue&type=style&index=0&id=1a360714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a360714",
  null
  
)

export default component.exports